'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addProductLazyLoading = exports.loadProducts = undefined;

var _IOLazyLoad = require('../IOLazyLoad');

var _IOLazyLoad2 = _interopRequireDefault(_IOLazyLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadSingleProduct = function loadSingleProduct(product) {
  product.classList.add('loaded');
  var entryImages = product.querySelectorAll('[data-image-src]');
  entryImages.forEach(function (image) {
    image.src = image.getAttribute('data-image-src');
  });
};

var loadProducts = exports.loadProducts = function loadProducts(entries, observer) {
  entries.forEach(function (entry) {
    if (observer) {
      if (entry.isIntersecting) {
        loadSingleProduct(entry.target);
        observer.unobserve(entry.target);
      }
    } else {
      loadSingleProduct(entry);
    }
  });
};

var addProductLazyLoading = exports.addProductLazyLoading = function addProductLazyLoading(products) {
  _IOLazyLoad2.default.setupObservers({
    queryString: '[data-io-lazyload]',
    callback: loadProducts
  });
};